module.exports = require("tslib");


//////////////////
// WEBPACK FOOTER
// external "tslib"
// module id = 0
// module chunks = 0